var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#EDF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 11.8332C14.288 11.8332 15.3327 10.7885 15.3327 9.49984C15.3327 8.21117 14.288 7.1665 12.9993 7.1665C11.7107 7.1665 10.666 8.21117 10.666 9.49984C10.666 10.7885 11.7107 11.8332 12.9993 11.8332Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6646 16.4999C17.6663 16.4043 17.6663 16.3068 17.6663 16.2083C17.6663 14.7587 15.5768 13.5833 12.9997 13.5833C10.4225 13.5833 8.33301 14.7587 8.33301 16.2083C8.33301 17.6578 8.33301 18.8333 12.9997 18.8333C14.3011 18.8333 15.2397 18.7417 15.9163 18.5783",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectContact);
export default __webpack_public_path__ + "static/media/select_contact.2eabc2f95e3961b13e2007bc5c5cebbc.svg";
export { ForwardRef as ReactComponent };